<template>
  <div class="news-cnt">
    <div class="ty-banner-1">
      <img
        alt="河南万杰智能科技股份"
        src="@img/subpage-banner.jpg"
        title="河南万杰智能科技股份"
      />
    </div>
    <search-bar></search-bar>
    <div class="blk-main content clearafter">
      <div class="blk plc">
        <div class="p12-curmbs-1" navcrumbs="">
          <b>您的位置:</b>
          <router-link to="/">主页</router-link>
          &gt; 搜索
          <strong>{{ searchText }}</strong>
          的结果
        </div>
      </div>
      <div class="clear"></div>
      <div class="blk-xs fl">
        <div class="fdh-01 blk">
          <div class="fdh-01-tit"><h3>导航菜单</h3></div>
          <div class="fdh-01-nav">
            <div class="fdh-01-nav-one">
              <h3><router-link to="/products/all">产品展示</router-link></h3>
            </div>
            <div class="fdh-01-nav-one">
              <h3><router-link to="/case/customer">客户见证</router-link></h3>
            </div>
            <div class="fdh-01-nav-one">
              <h3><router-link to="/about">关于万杰</router-link></h3>
            </div>
            <div class="fdh-01-nav-one">
              <h3><router-link to="/news/all">新闻动态</router-link></h3>
            </div>
            <div class="fdh-01-nav-one">
              <h3><router-link to="/about/contanct">联系我们</router-link></h3>
            </div>
          </div>
          <div class="clear"></div>
        </div>
      </div>
      <div class="blk-sm fr">
        <div class="lb-3n-ts-03 b">
          <div class="cplb-3n-ts-03-list">
            <dl v-for="(product, index) in dataList" :key="index">
              <dt>
                <router-link
                  target="_blank"
                  :to="
                    product.product_class_id | findpy(productTypes, product.id)
                  "
                >
                  <img
                    :alt="product.product_name"
                    :src="product.product_img_pc[0]"
                    :title="product.product_name"
                  />
                </router-link>
              </dt>
              <dd>
                <h4>
                  <router-link target="_blank" to="/products/detail">
                    <b>{{ product.product_name }}</b>
                  </router-link>
                </h4>
              </dd>
            </dl>
            <div class="clear"></div>
          </div>
        </div>
        <div class="clear"></div>
        <div class="fenye">
          <pagination
            :total="total"
            :page.sync="listQuery.page"
            :limit.sync="listQuery.limit"
            layout="total, prev, pager, next, jumper"
            :page-sizes="[12, 24, 36]"
            :hide-on-single-page="total < listQuery.limit"
            @pagination="product_info_list"
          />
        </div>
      </div>
      <div class="clear"></div>
    </div>
  </div>
</template>

<script>
import searchBar from "./common/searchBar.vue";
import utils from "@/api/to_py.js";

import Pagination from "@/components/common/pagination";
export default {
  data() {
    return {
      searchText: this.$route.query.q,
      dataList: [],
      total: 0,
      listQuery: {
        page: 1,
        limit: 9
      }
    };
  },
  components: {
    searchBar,
    Pagination
  },
  watch: {
    "$route.query"() {
      // '$route.query' 这个函数是关键
      // console.log(this.$route)
      this.searchText = this.$route.query.q;
      // Object.assign(this.$data, this.$options.data()); // 将跳转前的数据置空
      this.product_info_list(); // 再初始化当前的页面
    }
  },
  mounted: function() {
    // console.log(this.$route.query.q);
    this.getRroductType();
  },
  methods: {
    getRroductType: function() {
      this.$post("/Product/product_class_list", {}).then(response => {
        this.productTypes = response.data || [];
        this.product_info_list();
      });
    },
    product_info_list: function() {
      this.$post("/Product/product_info_list", {
        product_name: this.searchText,
        page: this.listQuery.page,
        limit: this.listQuery.limit
      })
        .then(res => {
          // console.log(res.data.data);
          this.dataList = res.data;
          this.total = res.count;
        })
        .catch(err => {
          console.log(err);
        });
    }
  },
  filters: {
    findpy(id, arrs, idd) {
      var baseurl = "/product/";
      arrs.forEach(element => {
        if (element.id == id) {
          baseurl += utils.ConvertPinyin(element.name) + "/" + idd + ".html";
          return;
        }
      });
      return baseurl;
    },
    toPy(parm, url) {
      var str = utils.ConvertPinyin(parm);
      if (url) str = url + str;
      return str;
    },
    compare(parm, type, id) {
      return parm == type ? "nav-active" : "";
    }
  }
};
</script>

<style lang="less">
@import "~@css/warp.less";
.news-cnt {
  background: rgba(247, 247, 247, 1);
  padding-bottom: 200px;
  .cplb-3n-ts-03-list {
    dl {
      width: 32.1%;
      border: 1px solid #dedede;
      margin-bottom: 20px;
      background: #fff;
      float: left;
      margin-right: 1.8%;
      &:nth-child(3n) {
        margin-right: 0;
      }
      &:hover {
        border-color: rgba(19, 181, 179, 1);
        a {
          color: rgba(19, 181, 179, 1);
        }
      }
      dd {
        padding: 0 20px;
        background: #ffffff;
        h4 {
          height: 45px;
          font-weight: normal;
          font-size: 16px;
          line-height: 45px;
          a {
            text-align: center;
            display: block;
            color: rgba(114, 114, 114, 1);
            overflow: hidden;
            text-overflow: ellipsis;
            white-space: nowrap;
          }
        }
      }
      dt {
        height: 296px;
        display: flex;
        align-items: center;
        justify-content: center;
        background: #ffffff;
        img {
          width: 100%;
          margin: 0 auto;
          display: block;
        }
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/search.vue